'use strict';

const interceptorConfig = (
	$locationProvider,
	$httpProvider,
	$animateProvider,
	$compileProvider
) => {
	$locationProvider.html5Mode(true);
	$animateProvider.classNameFilter(/pmt-animate/); // only run angular animate if this class is on a element

	const getErrorMessage = function (errorObject) {
		if (typeof errorObject === 'string') {
			if (errorObject.includes('TypeError')) {
				return 'Something went wrong. Please try again later.';
			}
			return errorObject;
		}
		if (errorObject.errorId && errorObject.error?.message) {
			return `${errorObject.error.message} Please contact support and provide this id: ${errorObject.errorId}`;
		}
		if (errorObject.data) {
			return getErrorMessage(errorObject.data);
		}
		if (errorObject.message) {
			return getErrorMessage(errorObject.message);
		}

		return 'Something went wrong. Please try again later.';
	};

	const interceptor = [
		'$window',
		'$q',
		'$rootScope',
		'pmtEnvService',
		function ($window, $q, $rootScope, pmtEnvService) {
			let responseError = function (response) {
				if (response.status === 401) {
					$window.location.href =
						pmtEnvService.loginUrl + '?returnUrl=' + encodeURIComponent($window.location.href);
				} else if (response.status === 403) {
					$rootScope.$broadcast('pmtInsufficientPermissionsError', {
						message: response.data.data
					});
					//$location.url('/forbidden/');
				} else if (response.status === 0) {
					$rootScope.$broadcast('pmtNetworkDown');
				} else if (response.status >= 500 && response.status < 600) {
					$rootScope.$broadcast('pmtServerError', {
						message: getErrorMessage(response.data || {})
					});
				}

				const error = new Error(
					`[${response.config.method}:${response.status}] ${JSON.stringify(
						response.data || response.config.url
					)}`
				);
				error.data = response.data;
				error.status = response.status;

				return $q.reject(error);
			};

			return {
				responseError: responseError
			};
		}
	];

	$httpProvider.interceptors.push(interceptor);
	$compileProvider.debugInfoEnabled(false);
};

module.exports = {
	interceptorConfig
};
